'use strict';

module.exports = {
  element: null
};



//////////////////
// WEBPACK FOOTER
// ./~/autocomplete.js/src/common/dom.js
// module id = 595
// module chunks = 0